// extracted by mini-css-extract-plugin
export default {"container":"metadata_container__MW4nD","value":"metadata_value__bNXlL"};